/* Diamond Shine — Animation Framework (Sprint 1) */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal(){
    var els = document.querySelectorAll('[data-ds-reveal]');
    if(!els.length) return;
    if(reduce || !('IntersectionObserver' in window)){
      els.forEach(function(e){ e.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold:.15, rootMargin:'0px 0px -8% 0px' });
    els.forEach(function(e){ io.observe(e); });
  }
  function shine(){
    if(reduce) return;
    var els = document.querySelectorAll('.ds-shine[data-ds-shine-auto]');
    if(!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('is-swept'); io.unobserve(en.target); }
      });
    }, { threshold:.5 });
    els.forEach(function(e){ io.observe(e); });
  }
  function init(){ reveal(); shine(); }
  if(document.readyState !== 'loading'){ init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();